/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Analytics constants for nr modules
 */

export const COLLAGE = 'Collage'

export const CAROUSEL = 'Carousel'

export const AUTOCOMPLETE = 'Autocomplete'

export const AUTOCOMPLETE_FAILURE = 'Autocomplete Failure'

export const AUTOCOMPLETE_HISTORICAL = 'Autocomplete Historical'

export const AUTOCOMPLETE_SUCCESS = 'Autocomplete Success'

export const AUTOCOMPLETE_TYPE = 'Autocomplete Type'

export const AUTOCOMPLETE_USE = 'Autocomplete Use'

export const NAVBAR_LIST = 'Navbar List'

export const NAVBAR_MAP = 'Navbar Map'

export const NAVBAR_ALERTS = 'Navbar Alerts'

export const NAVBAR_MESSAGED = 'Navbar Messaged'

export const NAVBAR_FAVORITES = 'Navbar Favorites'

export const AUTOCOMPLETE_LENGTH = 'length'

export const AUTOCOMPLETE_KEYSTROKES = 'keystrokes'

export const AUTOCOMPLETE_RETURNED = 'returned'

export const AUTOCOMPLETE_CLICK = 'click'

export const AUTOCOMPLETE_LOCATION = 'location'

export const AUTOCOMPLETE_EXIT = 'exit'

export const CCPA_REQUEST = 'CCPA Request'

export const CCPA_CONFIRMATION = 'CCPA Confirmation'
